// @copyright  2006-2024 West Indies Software Engineering Company Limited. All rights reserved.

import returns from './investment-returns.js';
import sales from './investment-sales.js';
import valuations from './investment-valuations.js';

export default [
    {
        path: '/:organisation/investment/investments',
        component: () =>
            import('@/pages/[organisation]/investment/investments/index.vue'),
        name: 'investment.investments.search-investments',
        meta: {
            loginRequired: true,
            permission: 'access.finance.investment.investments.view-investments',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/investment/investments/new.vue'),
                name: 'investment.investments.create-investment',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.investment.investments.create-investment',
                },
            },
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/investment/investments/[id].vue'),
                name: 'investment.investments.view-investment',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.investment.investments.view-investments',
                },
            },
            {
                path: ':id/edit-draft',
                component: () =>
                    import('@/pages/[organisation]/investment/investments/[id]/edit-draft.vue'),
                name: 'investment.investments.update-draft-investment',
                meta: {
                    loginRequired: true,
                    permission: 'access.finance.investment.investments.update-investment',
                },
            },
            ...returns,
            ...sales,
            ...valuations,
        ],
    },
];
